module.exports = __webpack_public_path__ + "img/nav02.7ed8fcdf.png";